import Resource from '@/api/Resource';
import Platform from '@/models/Platform';

export default class extends Resource {
  $name = 'server-jobs';

  $defaults() {
    return {
      id: null,
      status: '',
      platform_name: null,
      platform_id: null,
      server_name: null,
      type: '',
      is_test: null,
      is_complex: null,
      task_index: null,
      platform_job_id: null,
      command: null,
      description: '',
      fail_description: '',
      priority: null,
      difficulty: null,
      exception: null,
      failed_at: null,
      created_by: null,
      process_start_at: null,
      process_end_at: null,
      updated_at: null,
      created_at: null,
    };
  }

  $fill({platform}) {
    if (platform) {
      this.platform = new Platform(platform);
    }
  }

  get fullDescription() {
    return (this.description === null ? '' : this.description) + ' ' +
      (this.fail_description === null ? '' : this.fail_description) + ' ' +
      (this.exception === null ? '' : this.exception);
  }

  get shortPlatformName() {
    return this.platform_name.length > 12 ? this.platform_name.substring(0, this.platform_name.length - 12) : this.platform_name;
  }

  get statuses() {
    return {
      wait: 'Ожидает',
      process: 'Выполняется',
      done: 'Выполнена',
      canceled: 'Отменена',
      failed: 'Завершена с ошибкой',
    };
  }
}
